import React, { Fragment, useState, useEffect, useRef, useMemo, useCallback } from "react";
import QueryService from "../../services/QueryService";
import { useHistory, useLocation } from "react-router";
import SaveModal from "../saveModal/SaveModal";
import CustomLoader from "../customLoader/CustomLoader";
import ErrorModal from "../errorDisplayModal/ErrorDisplayModal";
import Loader from "react-loader-spinner";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import { changeQueryLocation } from "../../reducers/locationReducer";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { Modal } from "reactstrap";
import pageLeft from "../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../assets/images/CounselorCurrent/Page/center.png";
import "./QueryResult.css";
import QueryResultTable from "./QueryResultTable";
import {
  applySelectionChange,
  getSelectionModelForPage,
} from "../../utils/queryResultSelection";

// const ShowAlert=({number, onCancel, onConfirm})=> <SweetAlert
const ShowAlert = ({ number, onCancel, onConfirm }) => (
  <Modal
    centered
    isOpen
    toggle={onCancel}
    className="qr-select-all-modal"
    backdrop="static"
  >
    <div className="qr-select-all-content">
      <button
        type="button"
        className="qr-select-all-close"
        onClick={onCancel}
        aria-label="Close"
      >
        ×
      </button>
      <div className="qr-select-all-icon" aria-hidden="true">
        !
      </div>
      <p className="qr-select-all-title">
        You have selected {Number(number || 0).toLocaleString()} students!
      </p>
      <p className="qr-select-all-subtitle">Are you sure?</p>
      <div className="qr-select-all-actions">
        <button
          type="button"
          className="qr-select-all-btn qr-select-all-btn-cancel"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="qr-select-all-btn qr-select-all-btn-confirm"
          onClick={onConfirm}
        >
          Yes
        </button>
      </div>
    </div>
  </Modal>
);

const QueryResultComponent = () => {
  let history = useHistory();
  let location = useLocation();
  // console.log("location from the result", location);
  //const resultData = location?.state?.state;
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sortModel, setSortModel] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [queryResultData, setQueryResultData] = useState();
  const [tableData, setTableData] = useState([]);
  //const [exportData, setExportData] = useState(location && location.state && location.state.state && location.state.state.export)
  //const [stuPag, setStuPag] = useState(location.state.state.stud_arr);
  //const [dataForAllSelected, setDataForAllSelected] = useState(exportData.shift())
  const [clickedStudent, setClickedStudent] = useState();
  const [openSaveModal, setOpenSaveModal] = useState(false);
  //const [saveQueryData, setSaveQuerydata] = useState(resultData ? resultData.shift() : '')
  const [duplicateQueryData, setDuplicateQueryData] = useState(
    location && location.state ? location.state.duplicateQueryData : ""
  );
  //const [payloadForSaveResult, setPayloadForSaveResult] = useState(location && location.state && location.state.queryResultData ? location.state.queryResultData : '')
  const [from, setFrom] = useState(location?.state?.fromSavedQueriedResult);
  const [paginationCount, setPaginationCount] = useState();
  const [inputValue, setInputValue] = useState("");
  const [selectedRowFromTable, setSelectedRowFromTable] = useState();
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const [saveSelection, setSaveSelection] = useState([]);
  const savedSelectionRef = useRef([]);
  const shouldRestoreSelectionRef = useRef(false);
  const [loaderForExport, setLoaderForExport] = useState(false);
  const [loaderForSave, setLoaderForSave] = useState(false);
  const [showGroupMessageAlert, setShowGroupMessageAlert] = useState(false);
  const [filteredSaveSelection, setFilteredSaveSelection] = useState([]);
  const [newSelectedIds, setNewSelectedIds] = useState([]);
  const [expandedCells, setExpandedCells] = useState({}); // Track expanded cells

  const [hideSaveResultButton, setHideSaveResultButton] = useState(
    location?.state?.from
  );
  const dispatch = useDispatch();

  let userData = useSelector((state) => state.UserReducer.userObj);
  const selectedAllData = location?.state?.state?.export.filter(
    (item) => item.hasOwnProperty("id") === true
  );

  console.log("data", selectedAllData);
  console.log("from", from);
  const navigateToQuery = () => {
    localStorage.removeItem("query");
    history.push("/recruiter/search-query");
  };

  // useEffect(() => {
  //     if (openSaveModal === false) {
  //         location.state.openSaveModal = false
  //     }
  // }, [openSaveModal])

  // Map column sort field to backend sort field
  const sortFieldMap = {
    "5": "gpa",
    "0": "email",
    "1": "first_name",
    "2": "last_name",
    "3": "ethnicity",
    "4": "gender",
    // Added mappings for additional sortable columns
    "6": "athletics",
    "7": "activities",
    "8": "academics",
    "9": "interests",
    "10": "school_name",
    "11": "district_name",
    "12": "grade",
    "15": "completed_fafsa",
  };

  const getPageData = (overrideSort) => {
    setLoading(true);
    let queryData = JSON.parse(localStorage.getItem("query"));
    if (queryData) {
      queryData.page = page;
      // attach server-side sort when requested
      const rule = overrideSort || (sortModel && sortModel[0]);
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          queryData.sort_by = rule.sort === "desc" ? "desc" : "asc";
          queryData.field = mapped;
        } else {
          // remove sort params if column isn't supported by backend
          delete queryData.sort_by;
          delete queryData.field;
        }
      } else {
        delete queryData.sort_by;
        delete queryData.field;
      }
    }
    QueryService.getResultPage(queryData)
      .then(async (data) => {
        setQueryResultData(data.data);
        const newArrayOfObj = data.data.student_list.map(
          ({ 14: id, ...rest }) => ({
            id,
            ...rest,
          })
        );
        setTableData(newArrayOfObj);
        setPaginationCount(data.data.total_pages);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error from the service", error);
      });
  };

  // useEffect(()=>{
  //     console.log("getting called from the useEffect", exportData)
  // },[exportData])

  const convertArrayToTable = async (apiArray, fileName) => {
    const tableRows = apiArray
      .map((obj) => [
        `<tr>
              ${Object.keys(obj)
                .map(
                  (key) =>
                    `<td>${
                      obj[key] === null || key === "id" || obj[key] === ""
                        ? ""
                        : obj[key]
                    }</td>`
                )
                .join("")}
           <tr/>`,
      ])
      .join("");
    const table = `<table>${tableRows}</table>`?.trim();
    const xmlTable = createXMLTable(table, fileName);
    const downloadURL = createFileUrl(xmlTable);
    downloadFile(downloadURL, fileName);
  };

  const createXMLTable = (table, fileName) => {
    const xmlTable = `
              <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
             xmlns="http://www.w3.org/TR/REC-html40"
              >
                 <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
                 <head>
                    <xml>
                      <x:ExcelWorkbook>
                          <x:ExcelWorksheets>
                              <x:ExcelWorksheet>
                                  <x:Name>${fileName}</x:Name>
                                  <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                              </x:ExcelWorksheet>
                          </x:ExcelWorksheets>
                      </x:ExcelWorkbook>
                    </xml>
                 </head>
                 <body>
                   ${table}
                 </body>
              </html> `;
    return xmlTable;
  };

  const createFileUrl = (xmlTable) => {
    const tableBlob = new Blob([xmlTable], {
      type: "application/vnd.ms-excel;base64,",
    });
    const downloadURL = URL.createObjectURL(tableBlob);
    return downloadURL;
  };

  // useEffect(()=>{
  //     downloadFile(csvfile, "Test Download")
  // },[])
  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
  };

  const exportResult = () => {
    setLoaderForExport(true);
    let query = JSON.parse(localStorage.getItem("query"));
    // include current sort params used in table, if any
    if (query) {
      const rule = sortModel && sortModel[0];
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          query.sort_by = rule.sort === "desc" ? "desc" : "asc";
          query.field = mapped;
        } else {
          delete query.sort_by;
          delete query.field;
        }
      } else {
        delete query.sort_by;
        delete query.field;
      }
    }
    QueryService.exportResult(query)
      .then((data) => {
        console.log("data from the service", data);
        downloadFile(data.data.download, "My File");
        setLoaderForExport(false);
      })
      .catch((error) => {
        setLoaderForExport(false);
        console.log("error from the service", error);
        swal({
          title: "Error",
          text: "Failed to export results. Please try again later.",
          icon: "error",
          button: "OK",
        });
      });
  };
  useEffect(() => {
    if (!from) {
      getPageData();
    }
  }, [page]);

  useEffect(() => {
    if (from) {
      setTableData(selectedAllData);
    }
  }, []);

  const onCounselorContact = ({ row }) => {
    const counselorName = row["19"];
    const counselorId = row["18"];

    if (counselorId) {
      history.push({
        pathname: "/recruiter/counselors",
        state: {
          name: counselorName,
          id: counselorId,
        },
        openMessageModal: true,
        fromQueryResult: true,
      });
    } else {
      console.error("No counselor ID found");
    }
  };

  const onStudentContact = ({ row }) => {
    const studentId = row.id;

    if (studentId) {
      history.push({
        pathname: "/recruiter/students",
        state: {
          name: `${row["1"]} ${row["2"]}`,
          id: studentId,
        },
        openMessageModal: true,
        fromQueryResult: true,
      });
    } else {
      console.error("No student ID found");
    }
  };

  const onParentContact = ({ row }) => {
    const parentEmail = row["20"];
    const studentId = row.id;

    if (parentEmail && studentId) {
      history.push({
        pathname: "/recruiter/parents",
        state: {
          name: parentEmail,
          id: studentId,
          contactType: "parent",
        },
        openMessageModal: true,
        fromQueryResult: true,
      });
    } else {
      console.error("No parent email or student ID found");
    }
  };
  console.log("msg", filteredSaveSelection);
  // const a = filteredSaveSelection?.map((ele,index) => ele.id)
  // console.log("abt",a);
  const onGroupMessage = () => {
    const isSelectAll =
      filteredSaveSelection === "selected All" || saveSelection === "selected All";
    history.push({
      pathname: "/recruiter/students",
      state: filteredSaveSelection,
      openMessageModal: true,
      fromQueryResult: true,
      requireVerifyFlow: isSelectAll,
      payloadForSaveResult: queryResultData?.num_of_students,
      page: page,
    });
  };

  const handleGroupMessageClick = () => {
    const hasSelection =
      saveSelection === "selected All" ||
      (Array.isArray(saveSelection) && saveSelection.length > 0);
    if (!hasSelection) return;

    const isSelectAll =
      saveSelection === "selected All" || filteredSaveSelection === "selected All";
    if (isSelectAll && !from) {
      setShowGroupMessageAlert(true);
      return;
    }
    onGroupMessage();
  };

  const saveResult = () => {
    console.log("clicked");
    setOpenSaveModal(true);
  };

  const saveStudent = () => {
    setLoaderForSave(true);
    let payload;
    if (saveSelection === "selected All") {
      let detailObj = {};
      let finalObj = newSelectedIds.map((i, index) => {
        detailObj[index] = { school_id: i["16"], student_id: i["17"] };
      });
      payload = {
        is_all: false,
        // college_id: userData.college_id,
        // recruiter_id: userData.id,
        details: detailObj,
        // queries:JSON.parse(localStorage.getItem("query"))
      };
    } else {
      let detailObj = {};
      let finalObj = filteredSaveSelection.map((i, index) => {
        detailObj[index] = { school_id: i["16"], student_id: i["17"] };
      });
      payload = {
        is_all: false,
        // college_id: userData.college_id,
        // recruiter_id: userData.id,
        details: detailObj,
      };
    }
    QueryService.addStudent(payload)
      .then((data) => {
        console.log("data from the service", data);
        setLoaderForSave(false);
        swal({
          text: `Student Data Saved Successfully to My Student List.`,
          icon: "success",
          buttons: {
            OK: true,
          },
          closeOnClickOutside: false,
        })
        // .then((value) => {
        //   if (value === "OK") {
        //     history.push("/recruiter/campaign");
        //   }
        // });
      })
      .catch((error) => {
        console.log("error from save student service", error);
        setLoaderForSave(false);
        if (error.response.status == 409) {
          swal({
            text: error?.response?.data?.message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
        if (error.response.status == 500) {
          swal({
            text: error?.response?.data?.error_message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
      });
  };

  const cancel = () => {
    history.goBack();
  };

  useEffect(() => {
    if (Array.isArray(saveSelection)) {
      const ids = saveSelection.map((o) => o.id);
      let filtered = saveSelection.filter(
        ({ id }, index) => !ids.includes(id, index + 1)
      );
      setFilteredSaveSelection(filtered);
    } else if (typeof saveSelection === "string") {
      setFilteredSaveSelection("selected All");
    }
  }, [saveSelection]);

  useEffect(() => {
    if (!shouldRestoreSelectionRef.current || loading) return;
    shouldRestoreSelectionRef.current = false;
    setSaveSelection(savedSelectionRef.current);
  }, [tableData, loading]);

  const pageSelectionModel = useMemo(
    () => getSelectionModelForPage(saveSelection, tableData),
    [saveSelection, tableData]
  );

  const pageSelectionSet = useMemo(
    () => new Set(pageSelectionModel),
    [pageSelectionModel]
  );

  const selectedCount = useMemo(() => {
    if (saveSelection === "selected All") {
      return queryResultData?.num_of_students || tableData.length;
    }
    return Array.isArray(saveSelection) ? saveSelection.length : 0;
  }, [saveSelection, queryResultData, tableData]);

  const sortField = sortModel[0]?.field;
  const sortDirection = sortModel[0]?.sort || "asc";

  const onSelection = useCallback(
    (ids) => {
      const { nextSelection, selectAll } = applySelectionChange({
        ids,
        tableData,
        saveSelection,
        page,
        from,
      });

      const selectedRows = Array.isArray(nextSelection)
        ? nextSelection.filter((item) =>
            tableData.some((row) => String(row.id) === String(item.id))
          )
        : [];

      setSaveSelection(nextSelection);
      savedSelectionRef.current = nextSelection;
      setNewSelectedIds(selectedRows);
      setSelectAll(selectAll);
    },
    [tableData, saveSelection, page, from]
  );

  const handleRowToggle = useCallback(
    (row, selecting) => {
      const rowId = String(row.id);
      const currentPageIds = [...pageSelectionModel];
      const newPageIds = selecting
        ? currentPageIds.includes(rowId)
          ? currentPageIds
          : [...currentPageIds, rowId]
        : currentPageIds.filter((id) => id !== rowId);
      onSelection(newPageIds);
    },
    [pageSelectionModel, onSelection]
  );

  const handleSelectAllToggle = useCallback(() => {
    const isGlobalAll = saveSelection === "selected All";
    const allOnPageSelected =
      tableData.length > 0 &&
      tableData.every((row) => pageSelectionSet.has(String(row.id)));

    if (isGlobalAll || allOnPageSelected) {
      onSelection([]);
      return;
    }

    if (!from) {
      setSaveSelection("selected All");
      savedSelectionRef.current = "selected All";
      setSelectAll(true);
      setNewSelectedIds(tableData);
      return;
    }

    onSelection(tableData.map((row) => String(row.id)));
  }, [saveSelection, tableData, pageSelectionSet, from, onSelection]);

  const handleSort = useCallback(
    (column, direction) => {
      const rule = { field: column.sortField, sort: direction };
      setSortModel([rule]);
      if (!from) {
        if (page !== 1) {
          setPage(1);
        }
        getPageData(rule);
      }
    },
    [from, page]
  );

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const toggleCellExpansion = (rowId, field) => {
    const key = `${rowId}-${field}`;
    setExpandedCells(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  return (
    <Fragment>
      <AppHeader />
      <Modal centered={true} toggle={toggleModal} isOpen={isModalOpen}>
        <div className="modal-header">
          <h5 className="modal-title w3-text-blue">
            <center>Premium Info</center>
          </h5>
          <button
            type="button"
            className="close"
            onClick={toggleModal}
            aria-hidden="true"
          >
            ×
          </button>
        </div>
        <div
          style={{ padding: "25px", textAlign: "justify" }}
          className="modal-body"
        >
          <span style={{ fontSize: "medium" }}>
            To access Premium Services need to Subscribe it. For more details
            please contact to Admin.
          </span>
        </div>
        <div>
          <button onClick={toggleModal} className="premium-close">
            Close
          </button>
        </div>
      </Modal>
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="query-result-container">
            <div className="inner-query-result-container">
              <div className="view-result qr-header">
                <div>
                  <button
                  type="button"
                  className="qr-back-btn"
                  aria-label="Back"
                  onClick={() => history.goBack()}
                >
                  <img
                    src={require("../../assets/images/queryResult/back.png")}
                    alt="Back"
                    className="qr-back-img"
                  />
                </button>
                  <span className="qr-title-text" style={{ marginLeft: "10px" }}>Query Results</span>
                  <span className="qr-title-divider"> | </span>
                  <span className="qr-title-count">{`
                    ${
                      queryResultData
                        ? queryResultData?.num_of_students
                        : from
                        ? tableData.length
                        : 0
                    } Students Found`}</span>
                </div>
              </div>
              <div className="qr-subtitle-row">
                <p
                  style={{ color: "#333333", opacity: "0.8", margin: 0 }}
                  className="bold"
                >{`You are viewing ${
                  tableData ? tableData?.length : 0
                } Student out of ${
                  queryResultData ? queryResultData?.num_of_students : 0
                } Results`}</p>
              </div>
              {loading ? (
                <CustomLoader />
              ) : (
                <div
                  className={`qr-table-shell ${
                    paginationCount && paginationCount > 1
                      ? "table-container"
                      : "table-container-less"
                  }`}
                >
                  <QueryResultTable
                    tableData={tableData}
                    saveSelection={saveSelection}
                    pageSelectionSet={pageSelectionSet}
                    onRowToggle={handleRowToggle}
                    onSelectAllToggle={handleSelectAllToggle}
                    sortField={sortField}
                    sortDirection={sortDirection}
                    onSort={handleSort}
                    expandedCells={expandedCells}
                    toggleCellExpansion={toggleCellExpansion}
                    onStudentContact={onStudentContact}
                    onParentContact={onParentContact}
                    onCounselorContact={onCounselorContact}
                    selectedCount={selectedCount}
                  />
                </div>
              )}

              <div className="qr-footer-topline" />
              <div className="result-button-container">
                {/* {!from && (
                  <button
                    onClick={() => saveResult()}
                    className="modal-button-active"
                  >
                    Save Result
                  </button>
                )} */}
                {userData.is_premium === true ? (
                  <button
                    style={{ 
                      justifyContent: "center",
                      opacity: saveSelection.length > 0 ? 1 : 0.5,
                      cursor: saveSelection.length > 0 ? "pointer" : "not-allowed"
                    }}
                    className={`qr-footer-btn qr-footer-btn-primary ${saveSelection.length === 0 ? 'disabled' : ''}`}
                    onClick={() =>
                      saveSelection.length > 0 ? saveStudent() : null
                    }
                    disabled={saveSelection.length === 0}
                  >
                    <img src={require("../../assets/images/queryResult/save.png")} alt="" className="btn-icon" />
                    Save to My Students
                  </button>
                ) : (
                  <button
                    style={{ justifyContent: "center" }}
                    className="qr-footer-btn qr-footer-btn-primary"
                    onClick={toggleModal}
                  >
                    <img src={require("../../assets/images/queryResult/save.png")} alt="" className="btn-icon" />
                    Save to My Students
                  </button>
                )}
                <button
                  onClick={handleGroupMessageClick}
                  className={`qr-footer-btn qr-footer-btn-secondary ${saveSelection.length === 0 ? 'disabled' : ''}`}
                  style={{
                    opacity: saveSelection.length > 0 ? 1 : 0.5,
                    cursor: saveSelection.length > 0 ? "pointer" : "not-allowed"
                  }}
                  disabled={saveSelection.length === 0}
                >
                  <img src={require("../../assets/images/queryResult/group.png")} alt="" className="btn-icon" />
                  Group Message
                </button>
                <button
                  onClick={
                    from
                      ? () => convertArrayToTable(selectedAllData, "My File")
                      : () => exportResult()
                  }
                  style={{ justifyContent: "center" }}
                  className="qr-footer-btn qr-footer-btn-secondary flex"
                >
                  <img src={require("../../assets/images/queryResult/export.png")} alt="" className="btn-icon" />
                  Export Results
                  {loaderForExport && (
                    <span>
                      <Loader
                        type="TailSpin"
                        color="#E36221"
                        height={20}
                        width={20}
                      />
                    </span>
                  )}
                </button>
                <button
                  onClick={() => cancel()}
                  className="qr-footer-btn qr-footer-btn-secondary"
                >
                  <img src={require("../../assets/images/queryResult/close.png")} alt="" className="btn-icon" />
                  Cancel
                </button>
              </div>
              {(() => {
                const totalPages = from
                  ? Math.ceil((tableData?.length || 0) / 20)
                  : paginationCount || 0;
                return totalPages > 1 ? (
                  <div className="template-pagination-container">
                    <div className="custom-pagination" style={{ marginLeft: "auto" }}>
                      <button
                        type="button"
                        aria-label="Previous"
                        className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                        onClick={() => {
                          if (page > 1) {
                            savedSelectionRef.current = saveSelection;
                            shouldRestoreSelectionRef.current = true;
                            setPage(page - 1);
                          }
                        }}
                      >
                        <img
                          src={page === 1 ? pageLeftHide : pageLeft}
                          alt="Prev"
                          className="pagination-img"
                        />
                      </button>
                      <div className="pagination-center">
                        <img src={pageCenter} alt="Page" className="pagination-img" />
                        <span className="pagination-number" style={{color:'white'}}>{page}</span>
                      </div>
                      <button
                        type="button"
                        aria-label="Next"
                        className={`pagination-btn ${page >= totalPages ? "disabled" : ""}`}
                        onClick={() => {
                          if (page < totalPages) {
                            savedSelectionRef.current = saveSelection;
                            shouldRestoreSelectionRef.current = true;
                            setPage(page + 1);
                          }
                        }}
                      >
                        <img src={pageRight} alt="Next" className="pagination-img" />
                      </button>
                    </div>
                  </div>
                ) : null;
              })()}
            </div>
          </div>
          {showGroupMessageAlert && (
            <ShowAlert
              number={queryResultData?.num_of_students}
              onConfirm={() => {
                setShowGroupMessageAlert(false);
                onGroupMessage();
              }}
              onCancel={() => {
                setShowGroupMessageAlert(false);
                setSaveSelection([]);
                savedSelectionRef.current = [];
                setSelectAll(false);
              }}
            />
          )}
          {openSaveModal && (
            <SaveModal
              openSaveModal={openSaveModal}
              setOpenSaveModal={setOpenSaveModal}
              //duplicateQueryData={duplicateQueryData}
              //saveQueryData={selectedAllData}
              inputValueForSave={inputValue}
              setInputValueForSave={setInputValue}
              openErrorModal={true}
              setOpenErrorModal={setOpenErrorModal}
              //saveFromSavedResult={from ? true : false}
              // payloadForSaveResult={payloadForSaveResult}
            />
          )}
          {/* {
                openErrorModal && <ErrorModal
                    openErrorModal={openErrorModal}
                    setOpenErrorModal={setOpenErrorModal}
                    text="Query"
                />
            } */}
        </div>
      </div>
    </Fragment>
  );
};
export default QueryResultComponent;